<div class="motd-archive" appMarkdownImageLightbox>
  <div class="motd-archive__head">
    <h2 mat-dialog-title class="dialog-title-header motd-archive__dialog-title">
      <span class="dialog-title-header__icon" aria-hidden="true">
        <mat-icon>newspaper</mat-icon>
      </span>
      <span class="dialog-title-header__copy">
        <span class="dialog-title-header__heading" i18n="@@motd.archiveTitle">News-Archiv</span>
      </span>
    </h2>
    <button
      matIconButton
      type="button"
      mat-dialog-close
      i18n-aria-label="@@motd.archiveCloseAria"
      aria-label="Schließen"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="motd-archive__scroll">
    @if (loading()) {
      <div class="motd-archive__loading">
        <mat-progress-spinner color="primary" diameter="40" mode="indeterminate" />
      </div>
    } @else if (error(); as err) {
      <p class="motd-archive__error" role="alert">{{ err }}</p>
    } @else {
      @if (archiveMaxCursor()) {
        <div class="motd-archive__actions">
          <span
            class="motd-archive__mark-all-wrap"
            i18n-matTooltip="@@motd.archiveMarkAllReadDisabled"
            matTooltip="Alle Meldungen sind bereits als gelesen markiert."
            matTooltipPosition="below"
            [matTooltipDisabled]="archiveUnreadCount() > 0"
          >
            <button
              mat-stroked-button
              type="button"
              i18n="@@motd.archiveMarkAllRead"
              [disabled]="archiveUnreadCount() === 0"
              (click)="markArchiveAllRead()"
            >
              Alles als gelesen markieren
            </button>
          </span>
        </div>
      }
      @if (items().length === 0) {
        <p class="motd-archive__empty" i18n="@@motd.archiveEmpty">Keine archivierten Meldungen.</p>
      } @else {
        <mat-accordion class="motd-archive__accordion" [multi]="true">
          @for (it of items(); track it.id) {
            @let archiveMeta = formatArchiveDate(it.startsAt);
            @let titleDisplay = archiveItemTitleDisplay(it.id);
            @let itemUnread = isArchiveItemUnread(it);
            <div class="motd-archive__item" [class.motd-archive__item--read]="!itemUnread">
              <mat-expansion-panel
                #archivePanel
                class="motd-archive__panel"
                [class.motd-archive__panel--read]="!itemUnread"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title class="motd-archive__panel-title">
                    @if (titleDisplay.decorativeEmoji) {
                      <span class="motd-archive__decorative-emoji" aria-hidden="true">{{
                        titleDisplay.decorativeEmoji
                      }}</span>
                    }
                    <span
                      class="motd-archive__panel-title-text"
                      [attr.title]="titleDisplay.title"
                      >{{ titleDisplay.title }}</span
                    >
                  </mat-panel-title>
                  <mat-panel-description class="motd-archive__panel-meta">
                    @if (archiveMeta) {
                      <span class="motd-archive__panel-meta-text">{{ archiveMeta }}</span>
                    }
                  </mat-panel-description>
                </mat-expansion-panel-header>
                @if (htmlById()[it.id]; as safe) {
                  <div
                    class="motd-archive__body markdown-body"
                    [attr.inert]="archivePanel.expanded ? null : ''"
                    [innerHTML]="safe"
                  ></div>
                }
              </mat-expansion-panel>
              <div class="motd-archive__item-footer">
                <span
                  class="motd-archive__read-state"
                  [class.motd-archive__read-state--unread]="itemUnread"
                >
                  @if (itemUnread) {
                    <span class="motd-archive__unread-dot" aria-hidden="true"></span>
                    <span i18n="@@motd.archiveItemUnreadStatus">Ungelesen</span>
                  } @else {
                    <mat-icon aria-hidden="true">done</mat-icon>
                    <span i18n="@@motd.archiveMarkItemRead">Gelesen</span>
                  }
                </span>
                @if (itemUnread) {
                  <button
                    matButton="text"
                    type="button"
                    class="motd-archive__mark-read"
                    i18n-aria-label="@@motd.archiveMarkItemReadAria"
                    aria-label="Diese Meldung als gelesen markieren"
                    (click)="markArchiveItemRead(it, $event)"
                  >
                    <mat-icon aria-hidden="true">done</mat-icon>
                    <span i18n="@@motd.archiveMarkItemReadAction">Als gelesen markieren</span>
                  </button>
                }
              </div>
            </div>
          }
        </mat-accordion>
      }
      @if (nextCursor()) {
        <div class="motd-archive__load-more" [attr.aria-busy]="loadingMore() ? 'true' : null">
          <button
            matButton="tonal"
            type="button"
            i18n="@@motd.archiveLoadMore"
            [disabled]="loadingMore()"
            (click)="loadMoreArchive()"
          >
            Weitere Meldungen laden
          </button>
          @if (loadingMore()) {
            <mat-progress-spinner
              class="motd-archive__load-more-spinner"
              color="primary"
              diameter="28"
              mode="indeterminate"
              aria-hidden="true"
            />
          }
        </div>
      }
    }
  </mat-dialog-content>
</div>
